import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL; // Ex: "http://localhost:5000/api"

// Créer une nouvelle relance fournisseur
export const createRelanceFournisseur = async (relanceData) => {
  const response = await axios.post(`${API_URL}/relances-fournisseurs`, relanceData);
  return response.data;
};

// Lister toutes les relances fournisseurs
export const fetchRelancesFournisseurs = async () => {
  const response = await axios.get(`${API_URL}/relances-fournisseurs`);
  return response.data;
};

// Récupérer une relance fournisseur par ID
export const fetchRelanceFournisseurById = async (id) => {
  const response = await axios.get(`${API_URL}/relances-fournisseurs/${id}`);
  return response.data;
};

// Mettre à jour une relance fournisseur
export const updateRelanceFournisseur = async (id, relanceData) => {
  const response = await axios.put(`${API_URL}/relances-fournisseurs/${id}`, relanceData);
  return response.data;
};

// Supprimer une relance fournisseur
export const deleteRelanceFournisseur = async (id) => {
  await axios.delete(`${API_URL}/relances-fournisseurs/${id}`);
};
